import {
	SERVER_GET_REPORTS,
	SET_REPORTS,
	SET_REPORT_DETAILS,
	SET_NEW_CHAT_MESSAGE,
	SERVER_UPDATE_REPORT_ASSIGNMENT,
	SET_UPDATED_REPORT_ASSIGNMENT,
	SERVER_UPDATE_REPORT_PRIORITY,
	SET_REPORT_PRIORITY,
	SERVER_COMPLETE_REPORT,
	SERVER_DECLINE_REPORT,
	SERVER_DELETE_REPORT,
	SERVER_RESTORE_REPORT,
	UPDATE_REPORT_STATUS,
	SET_REPORT_VISIBILITY,
	SERVER_UPDATE_REPORT_DATA,
	EDIT_REPORT_SUCCESS,
	EDIT_REPORT_ERROR,
	DISCONNECT_REPORTS,
	CONNECT_REPORTS,
	SET_REPORT_DEADLINE,
	SET_REPORT_RESUBMISSION,
	SERVER_SET_REPORT_RESUBMISSION,
	SERVER_SET_REPORT_DEADLINE,
	ADD_REPORT_USERCOMMENT,
	SERVER_SEND_REPORT_USERCOMMENT,
	SERVER_REASSIGN_REPORT,
	SERVER_STOP_OBSERVING_REPORT,
	STOP_OBSERVING_REPORT,
	SERVER_ASSIGN_REPORT,
	ASSIGN_REPORT,
	UPDATE_REPORTS,
	SERVER_REMOVE_REPORT_IN_PROCESS,
	SERVER_SET_REPORT_IN_PROCESS,
	SERVER_GET_REPORT_DETAILS,
	SERVER_GET_UNCONTROLLED_REPORTS,
	SET_UNCONTROLLED_REPORTS,
	SERVER_PASS_REPORTS,
	SET_REPORTS_CONTROLLED,
	SET_PASS_REPORTS_SUMMARY,
	RELOAD_REPORT_EDIT_IMAGE,
	SERVER_EDIT_REPORT_IMAGE,
	SIGNOUT_USER,
	UPDATE_REPORT_ORGANISATION,
	UPDATE_REPORT_RESPONSIBLE,
	REMOVE_CITIZEN_COMPLETE,
	SET_REPORTS_FILTER,
	SET_REPORTS_TABLE_PAGE,
	SET_REPORTS_TABLE_PAGE_SIZE,
	SET_REPORTS_TABLE_COLUMN_SIZE,
	SET_REPORT_DETAILS_AUTH_ERROR,
	SERVER_UPDATE_REPORT_OBSERVER,
	UPDATE_REPORT_OBSERVER,
	ADD_REPORT_LOG_ITEM,
	GET_REPORT_DETAILS_ERROR,
	SERVER_DUPLICATE_REPORT,
	DUPLICATE_REPORT,
	SERVER_UPDATE_CHAT_MESSAGE_STATUS,
	UPDATE_REPORT_USER_COMMENT,
	DELETE_REPORT_USER_COMMENT,
	SERVER_UPDATE_REPORT_USER_COMMENT,
	SERVER_DELETE_REPORT_USER_COMMENT,
	SET_REPORT_DETAILS_ORIGIN,
	SET_REPORT_SEARCH_RESULTS,
	UPDATE_REPORT_RECORDS,
	SERVER_GET_CONNECTED_REPORTS,
	SET_CONNECTED_REPORTS,
	SERVER_GET_ADDITIONAL_REPORT_DATA,
	SET_ADDITIONAL_REPORT_DATA,
	SERVER_UPDATE_REPORT_CONNECTIONS,
	SET_REPORT_CONNECTIONS,
	COMMON_ERROR,
	SERVER_SET_ANONYMIZE_STATE,
	UPDATE_REPORT_ANONYMIZE_STATE
} from 'constants/ActionTypes';
import _ from 'lodash';

const INITIAL_STATE = {
	reports: [],
	assignedReports: [],
	selectedReport: [],
	selectedReportAuth: {},
	selectedReportMapReloadKey: 0,
	newReportCounter: 0,
	uncontrolled: [],
	editConnectedReports: [],
	passReportsSummary: {
		succesful: [],
		failed: []
	},
	loading: {
		reports: false,
		reportDetailsLoading: false,
		reportDetailsForbidden: false,
		priorityPicker: false,
		completeReport: false,
		declineReport: false,
		deleteReport: false,
		restoreReport: false,
		toggleAssignment: {
			assignedType: null,
			assignedId: null,
			status: false
		},
		assignReport: false,
		editReport: false,
		setDeadlineLoading: false,
		setResubmissionLoading: false,
		sendUserComment: false,
		exitObserveOnly: {
			reAssignReport: false,
			stopObeserving: false
		},
		removeInProcess: false,
		setInProcess: false,
		getUncontrolledReports: false,
		passReports: false,
		editReportImage: false,
		updateObserver: false,
		duplicateReport: false,
		userComments: [],
		editConnectedReports: false,
		connectReports: false,
		anonymizeReport: false
	},
	imageReloadKey: 0,
	tableFilter: {
		reports: [],
		observer: [],
		archive: [],
		reportsResult: [],
		observerResult: [],
		archiveResult: [],
		reportSearchResult: []
	},
	tablePage: {
		reports: 0,
		observer: 0,
		archive: 0
	},
	tablePageSize: {
		reports: 10,
		observer: 10,
		archive: 10
	},
	tableColumnsSize: {
		reports: [],
		observer: [],
		archive: []
	},
	reportDetailsOrigin: null,
	errors: {
		selectedReport: false,
		selectedReportPermission: false
	}
};

export default (state = INITIAL_STATE, action) => {
	if (process.env.NODE_ENV !== 'production') console.log(action);
	switch (action.type) {
		case COMMON_ERROR:
			return {
				...state,
				loading:
					action.payload.loadingType === 'report'
						? { ...state.loading, [action.payload.loadingKey]: INITIAL_STATE.loading[action.payload.loadingKey] }
						: state.loading
			};
		case SIGNOUT_USER:
			return INITIAL_STATE;
		// Meldungen laden
		case SET_REPORTS:
			return {
				...state,
				reports: Array.isArray(action.payload.reports) ? action.payload.reports : [],
				assignedReports: Array.isArray(action.payload.assignedReports) ? action.payload.assignedReports : [],
				loading: {
					...state.loading,
					reports: false
				}
			};
		// Daten der Meldungen verändern
		case UPDATE_REPORTS:
			return {
				...state,
				reports: state.reports.map(report => {
					const updateIndex = _.findIndex(action.payload, {
						reportId: report.reportId
					});
					if (updateIndex === -1) return report;
					return {
						...report,
						...action.payload[updateIndex].updateData
					};
				})
			};
		// Details zur ausgewählten Meldung laden
		case SET_REPORT_DETAILS:
			return {
				...state,
				selectedReport: Array.isArray(action.payload.reportDetails) ? action.payload.reportDetails : [],
				selectedReportMapReloadKey: new Date().getTime(),
				loading: INITIAL_STATE.loading,
				selectedReportAuth: action.payload.authorization
			};
		// Neue Chatnachricht in der ausgewählten Meldung eintragen
		case SET_NEW_CHAT_MESSAGE:
			return {
				...state,
				selectedReport: state.selectedReport.map(report =>
					report.chat.chatId === action.payload.chatData.chatId
						? {
								...report,
								chat: {
									...report.chat,
									conversation: [...report.chat.conversation, action.payload.chatData.message]
								}
						  }
						: report
				)
			};
		// Meldung einem Nutzer oder einer Gruppe zuordnen / zuordnung entfernen
		case SET_UPDATED_REPORT_ASSIGNMENT:
			return {
				...state,
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											assignments: action.payload.updatedAssignments
									  }
									: report
						  )
						: state.selectedReport,
				loading:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? {
								...state.loading,
								toggleAssignment: INITIAL_STATE.loading.toggleAssignment
						  }
						: state.loading
			};
		// Priorität der Meldung festlegen
		case SET_REPORT_PRIORITY:
			return {
				...state,
				reports: state.reports.map(report =>
					report.reportId === action.payload.reportId
						? {
								...report,
								priorityIndex: action.payload.priority
						  }
						: report
				),
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											priorityIndex: action.payload.priority
									  }
									: report
						  )
						: state.selectedReport,
				loading:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? {
								...state.loading,
								priorityPicker: false
						  }
						: state.loading
			};
		case UPDATE_REPORT_STATUS:
			return {
				...state,
				reports: state.reports.map(report =>
					report.reportId === action.payload.reportId
						? {
								...report,
								status: action.payload.status,
								...action.payload.dataUpdate
						  }
						: report
				),
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map((report, index) => {
								if (index !== 0) return report;
								return {
									...report,
									status: action.payload.status,
									...action.payload.dataUpdate
								};
						  })
						: state.selectedReport,
				loading:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? {
								...state.loading,
								completeReport: false,
								declineReport: false,
								deleteReport: false,
								restoreReport: false,
								setInProcess: false,
								removeInProcess: false
						  }
						: state.loading
			};

		case SET_REPORT_VISIBILITY:
			return {
				...state,
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											isVisible: action.payload.isVisible
									  }
									: report
						  )
						: state.selectedReport,
				uncontrolled: state.uncontrolled.map(r =>
					r[0] && r[0].reportData.reportId === action.payload.reportId
						? _.compact([{ ...r[0], reportData: { ...r[0].reportData, visible: action.payload.isVisible } }, r[1]])
						: r
				)
			};

		case DISCONNECT_REPORTS:
			if (state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId)
				return {
					...state,
					selectedReport: state.selectedReport.filter(report => report.reportId !== action.payload.connectedReportId)
				};
		case CONNECT_REPORTS:
			const connectedReports = action.payload.reportData.filter(r => r.reportId !== action.payload.reportId).map(r => r.reportId);
			return {
				...state,
				reports: state.reports
					.filter(report => !connectedReports.includes(report.reportId))
					.map(report => (report.reportId === action.payload.reportId ? { ...report, connectedReports } : report)),
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? action.payload.reportData
						: state.selectedReport
			};
		case SET_REPORT_DEADLINE:
			return {
				...state,
				reports: state.reports.map(report =>
					report.reportId === action.payload.reportId ? { ...report, deadline: action.payload.deadline } : report
				),
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											deadline: action.payload.deadline
									  }
									: report
						  )
						: state.selectedReport,
				loading:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? { ...state.loading, setDeadlineLoading: false }
						: state.loading
			};

		case SET_REPORT_RESUBMISSION:
			return {
				...state,
				reports: state.reports.map(report =>
					report.reportId === action.payload.reportId
						? {
								...report,
								resubmission: action.payload.resubmission
						  }
						: report
				),
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											resubmission: action.payload.resubmission
									  }
									: report
						  )
						: state.selectedReport,
				loading:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? { ...state.loading, setResubmissionLoading: false }
						: state.loading
			};

		case ADD_REPORT_USERCOMMENT:
			return {
				...state,
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											userComments: [...report.userComments, action.payload.comment]
									  }
									: report
						  )
						: state.selectedReport,
				loading:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? { ...state.loading, sendUserComment: false }
						: state.loading
			};
		case ADD_REPORT_LOG_ITEM:
			return {
				...state,
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											reportLog: [...report.reportLog, action.payload.logItem]
									  }
									: report
						  )
						: state.selectedReport,
				loading:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? { ...state.loading, sendUserComment: false }
						: state.loading
			};
		case STOP_OBSERVING_REPORT:
			return {
				...state,
				reports: action.payload.removeReport
					? state.reports.filter(report => report.reportId !== action.payload.reportId)
					: state.reports.map(r => (r.reportId === action.payload.reportId ? { ...r, observeOnly: false } : r)),
				loading:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId ? INITIAL_STATE.loading : state.loading
			};

		case ASSIGN_REPORT:
			return {
				...state,
				reports: action.payload.selfAssignment
					? state.reports
					: action.payload.observeOnly
					? state.reports.map(report => (report.reportId === action.payload.reportId ? { ...report, observeOnly: true } : report))
					: state.reports.filter(report => report.reportId !== action.payload.reportId),
				loading:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId ? INITIAL_STATE.loading : state.loading
			};
		case SET_UNCONTROLLED_REPORTS:
			return {
				...state,
				uncontrolled: action.payload.reports,
				loading: { ...state.loading, getUncontrolledReports: false }
			};
		case SET_REPORTS_CONTROLLED:
			return {
				...state,
				uncontrolled: state.uncontrolled.filter(
					report => !action.payload.reports.find(reportId => report[0].reportData.reportId === reportId)
				)
			};
		case SET_PASS_REPORTS_SUMMARY:
			return { ...state, passReportsSummary: action.payload, loading: { ...state.loading, passReports: false } };
		case RELOAD_REPORT_EDIT_IMAGE:
			return {
				...state,
				selectedReport: state.selectedReport.map(report => {
					return {
						...report,
						images: report.images.map(image => (image.id === action.payload.imageId ? { ...image, url: image.url } : image))
					};
				}),
				loading: { ...state.loading, editReportImage: false },
				imageReloadKey: new Date().getTime()
			};
		case UPDATE_REPORT_ORGANISATION:
			return {
				...state,
				uncontrolled: state.uncontrolled.map(report =>
					report[0].reportData.reportId === action.payload.reportId
						? _.compact([
								{
									...report[0],
									responsible: {
										...report[0].responsible,
										organisationId: action.payload.organisationId,
										organisationName: action.payload.organisationName,
										organisationEmail: action.payload.organisationEmail,
										responsibleId: action.payload.responsibleId,
										responsibles: action.payload.responsibles
									}
								},
								report[1]
						  ])
						: report
				)
			};
		case UPDATE_REPORT_RESPONSIBLE:
			return {
				...state,
				uncontrolled: state.uncontrolled.map(report =>
					report[0].reportData.reportId === action.payload.reportId
						? _.compact([
								{
									...report[0],
									responsible: {
										...report[0].responsible,
										responsibleId: action.payload.responsibleId
									}
								},
								report[1]
						  ])
						: report
				)
			};
		case UPDATE_REPORT_OBSERVER:
			return {
				...state,
				selectedReport:
					action.payload && state.selectedReport[0]
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											observer:
												action.payload.type === 'remove'
													? report.observer.filter(o => o.responsibleId !== action.payload.observer.responsibleId)
													: [...report.observer, action.payload.observer]
									  }
									: report
						  )
						: state.selectedReport,
				loading: { ...state.loading, updateObserver: false }
			};
		case REMOVE_CITIZEN_COMPLETE:
			return {
				...state,
				selectedReport: state.selectedReport[0]
					? state.selectedReport.map(report =>
							report.reportId === action.payload.reportId ? { ...report, citizenCompleted: false } : report
					  )
					: state.selectedReport
			};

		case SET_REPORTS_FILTER:
			return { ...state, tableFilter: { ...state.tableFilter, [action.payload.table]: action.payload.filter } };
		case SET_REPORTS_TABLE_PAGE:
			return { ...state, tablePage: { ...state.tablePage, [action.payload.table]: action.payload.page } };
		case SET_REPORTS_TABLE_PAGE_SIZE:
			return { ...state, tablePageSize: { ...state.tablePageSize, [action.payload.table]: action.payload.pageSize } };
		case SET_REPORTS_TABLE_COLUMN_SIZE:
			return { ...state, tableColumnsSize: { ...state.tableColumnsSize, [action.payload.table]: action.payload.columns } };
		case SET_REPORT_DETAILS_AUTH_ERROR:
			// Lesen der Meldung ist nicht erlaubt
			return { ...state, loading: { ...state.loading, reportDetailsLoading: false, reportDetailsForbidden: true } };
		case UPDATE_REPORT_USER_COMMENT:
			return {
				...state,
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											userComments: report.userComments.map(c =>
												c.id === action.payload.commentId ? { ...c, ...action.payload.updateData } : c
											)
									  }
									: report
						  )
						: state.selectedReport,
				loading: { ...state.loading, userComments: state.loading.userComments.filter(id => id !== action.payload.commentId) }
			};

		case DELETE_REPORT_USER_COMMENT:
			return {
				...state,
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											userComments: report.userComments.filter(c => c.id !== action.payload.commentId)
									  }
									: report
						  )
						: state.selectedReport,
				loading: { ...state.loading, userComments: state.loading.userComments.filter(id => id !== action.payload.commentId) }
			};
		case SET_REPORT_DETAILS_ORIGIN:
			return {
				...state,
				reportDetailsOrigin: action.payload.origin
			};
		case SET_REPORT_SEARCH_RESULTS:
			return {
				...state,
				tableFilter: { ...state.tableFilter, reportSearchResult: action.payload.searchResult.map(r => r.reportId) }
			};

		case UPDATE_REPORT_RECORDS:
			return {
				...state,
				reports: state.reports.map(report =>
					report.reportId === action.payload.reportId
						? {
								...report,
								...action.payload.recordCols
						  }
						: report
				),
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report =>
								report.reportId === action.payload.reportId
									? {
											...report,
											records: report.records.map(r => {
												const record = action.payload.records.find(e => e.idRecords === r.idRecords);
												if (record) return { ...r, value: record.value };
												return r;
											})
									  }
									: report
						  )
						: state.selectedReport
			};
		case SET_CONNECTED_REPORTS:
			return {
				...state,
				reports: _.unionBy(
					state.reports.map(r => {
						const updatedData = action.payload.connectedReports.find(c => c.reportId === r.reportId);
						if (updatedData) return { ...r, ...updatedData };
						return r;
					}),
					action.payload.connectedReports,
					'reportId'
				),
				loading: { ...state.loading, editConnectedReports: false }
			};

		case SERVER_GET_CONNECTED_REPORTS:
			return {
				...state,
				loading: { ...state.loading, editConnectedReports: true }
			};

		case SERVER_GET_ADDITIONAL_REPORT_DATA:
			return {
				...state,
				reports: state.reports.map(r => (r.reportId === action.payload.reportId ? { ...r, loadingAdditionalData: true } : r))
			};
		case SET_ADDITIONAL_REPORT_DATA:
			return {
				...state,
				reports: state.reports.map(r =>
					r.reportId === action.payload.reportId ? { ...r, ...action.payload.reportData, loadingAdditionalData: undefined } : r
				)
			};
		case SERVER_UPDATE_REPORT_CONNECTIONS:
			return {
				...state,
				loading: {
					...state.loading,
					connectReports: true
				}
			};
		case SET_REPORT_CONNECTIONS:
			return {
				...state,
				loading: {
					...state.loading,
					connectReports: false
				}
			};
		// ---> loading Flags setzen
		// Loading Flag Priorität wählen Button
		case SERVER_GET_REPORT_DETAILS:
			return {
				...state,
				selectedReport: [],
				loading: { ...state.loading, reportDetailsLoading: true, reportDetailsForbidden: false },
				errors: { ...state.errors, selectedReport: false, selectedReportPermission: false }
			};
		case SERVER_UPDATE_REPORT_PRIORITY:
			return {
				...state,
				loading: { ...state.loading, priorityPicker: true }
			};
		// Loading Flag Erledigt Button
		case SERVER_COMPLETE_REPORT:
			return {
				...state,
				loading: { ...state.loading, completeReport: true }
			};
		// Loading Flag Ablehnen Button
		case SERVER_DECLINE_REPORT:
			return {
				...state,
				loading: { ...state.loading, declineReport: true }
			};
		// Loading Flag Löschen Button
		case SERVER_DELETE_REPORT:
			return {
				...state,
				loading: { ...state.loading, deleteReport: true }
			};
		// Loading Flag Wiederherstellen Button
		case SERVER_RESTORE_REPORT:
			return {
				...state,
				loading: { ...state.loading, restoreReport: true }
			};
		// Loading Flag User oder Gruppe zuweisen
		case SERVER_UPDATE_REPORT_ASSIGNMENT:
			return {
				...state,
				loading: {
					...state.loading,
					toggleAssignment: {
						assignedType: action.payload.assignedType,
						assignedId: action.payload.assignedId,
						status: true
					}
				}
			};
		case SERVER_UPDATE_REPORT_DATA:
			return {
				...state,
				loading: { ...state.loading, editReport: true }
			};
		case SERVER_SET_REPORT_DEADLINE:
			return {
				...state,
				loading: { ...state.loading, setDeadlineLoading: true }
			};
		case SERVER_SET_REPORT_RESUBMISSION:
			return {
				...state,
				loading: { ...state.loading, setResubmissionLoading: true }
			};
		case SERVER_SEND_REPORT_USERCOMMENT:
			return {
				...state,
				loading: { ...state.loading, sendUserComment: true }
			};
		case SERVER_REASSIGN_REPORT:
			return {
				...state,
				loading: {
					...state.loading,
					exitObserveOnly: {
						...state.loading.exitObserveOnly,
						reAssignReport: true
					}
				}
			};
		case SERVER_STOP_OBSERVING_REPORT:
			return {
				...state,
				loading: {
					...state.loading,
					exitObserveOnly: {
						...state.loading.exitObserveOnly,
						stopObeserving: true
					}
				}
			};
		case SERVER_ASSIGN_REPORT:
			return {
				...state,
				loading: { ...state.loading, assignReport: true }
			};
		case SERVER_SET_REPORT_IN_PROCESS:
			return {
				...state,
				loading: { ...state.loading, setInProcess: true }
			};
		case SERVER_REMOVE_REPORT_IN_PROCESS:
			return {
				...state,
				loading: { ...state.loading, removeInProcess: true }
			};
		case SERVER_GET_UNCONTROLLED_REPORTS:
			return {
				...state,
				loading: { ...state.loading, getUncontrolledReports: true }
			};
		case SERVER_PASS_REPORTS:
			return { ...state, loading: { ...state.loading, passReports: true } };
		case SERVER_EDIT_REPORT_IMAGE:
			return { ...state, loading: { ...state.loading, editReportImage: true } };
		case SERVER_UPDATE_REPORT_OBSERVER:
			return { ...state, loading: { ...state.loading, updateObserver: true } };
		case SERVER_DUPLICATE_REPORT:
			return { ...state, loading: { ...state.loading, duplicateReport: true } };
		case DUPLICATE_REPORT:
			return { ...state, loading: { ...state.loading, duplicateReport: false } };
		case EDIT_REPORT_SUCCESS:
			return {
				...state,
				reports: state.reports.map(report =>
					report.reportId === action.payload.reportId
						? {
								...report,
								...action.payload
						  }
						: report
				),
				loading: { ...state.loading, editReport: false }
			};
		case EDIT_REPORT_ERROR:
			return {
				...state,
				loading: { ...state.loading, editReport: false }
			};
		case SERVER_GET_REPORTS:
			return {
				...state,
				loading: { ...state.loading, reports: true }
			};
		case GET_REPORT_DETAILS_ERROR:
			return {
				...state,
				loading: { ...state.loading, selectedReport: false },
				errors: { ...state.errors, selectedReport: true, selectedReportPermission: action.payload.permissionError }
			};

		case SERVER_UPDATE_CHAT_MESSAGE_STATUS:
			return {
				...state,
				selectedReport: state.selectedReport.map(r =>
					r.chat.chatId === action.payload.chatId
						? {
								...r,
								chat: {
									...r.chat,
									conversation: r.chat.conversation.map(m =>
										m.type === 'received' && m.status === 0 && m.messageId <= action.payload.lastMessageId
											? { ...m, status: 1 }
											: m
									)
								}
						  }
						: r
				),
				reports: state.reports.map(r =>
					r.reportId === action.payload.reportId ? { ...r, newChatMessages: action.payload.remainingUnreadMessages } : r
				)
			};

		case SERVER_UPDATE_REPORT_USER_COMMENT:
		case SERVER_DELETE_REPORT_USER_COMMENT:
			return { ...state, loading: { ...state.loading, userComments: [...state.loading.userComments, action.payload.commentId] } };
		// loading Flags setzen <---

		case SERVER_SET_ANONYMIZE_STATE:
			return { ...state, loading: { ...state.loading, anonymizeReport: true } };

		case UPDATE_REPORT_ANONYMIZE_STATE:
			return {
				...state,
				selectedReport:
					state.selectedReport[0] && state.selectedReport[0].reportId === action.payload.reportId
						? state.selectedReport.map(report => ({ ...report, hidePersData: action.payload.hidePersData }))
						: state.selectedReport,
				loading: { ...state.loading, anonymizeReport: false }
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/Reports.js